module.exports = __webpack_public_path__ + "static/media/a22.a123a29d.pdf";